<template>    
    <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
        message="Enter the Room Type name, enter what you want to appear in the Room Description, select the default Floor Type. The Unit size will be one by default. Choose the Daily Task, and if a Policing task is required, select a policing task."
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_ext()">
                <FormDynamic
                    :form_format="form_format"
                    :form_data="form_data"
                    :array_options="array_options"
                    :for_update="false"
                >
                    <template v-slot:more-fields>
                        <div class="formdynamic__item py-0 col-md-6 p-0" style="margin-top: 20px;" v-if="form_data.patient">
                            <div class="formdynamic__item__field">
                                <label for="Vacant bed adjustment:" class="modal-label">Vacant bed adjustment: </label>
                                    <select size="" class="input-field custom-select" v-model="form_data.vacant_bed_adjustment_id">
                                        <option value="">Select an option</option>
                                        <option :value="item.id" v-for="(item, index) in array_options.vacant_bed_adjustment_id" :key="index" v-html="item.name" />
                                </select>
                            </div>
                        </div>
                    </template>
                </FormDynamic>

                <div class="row mb-3 no-gutters" style="margin-top:30px;">
                    <div class="col-12">
                        <ul class="row mb-0 no-gutters nav nav-tabs tabs__custom" id="myTab" role="tablist">
                            <li class="col-md-6 nav-item tabs__custom__item" v-for="(val, i) in tabs" :key="i">
                                <a :class="`nav-link ${i === 0 ? 'active' : '' } tabs__custom__link`" data-toggle="tab" :href="val.href_child_tab">
                                    {{ val.name }}
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content mt-3" style="margin-top:30px;">
                            <div class="tab-pane fade show active" id="daily" role="tabpanel" aria-labelledby="instant-tab">
                                <div class="tab-content">
                                    <div class="tab-pane fade active show" style="top:0px;">
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="w-100 table-responsive overflow-y--1">
                                                    <table class="table">
                                                        <thead style="background-color: #f1f1f1;">
                                                            <tr>
                                                                <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, i) in tasks" :key="i">
                                                                <td>
                                                                    <span class="custom-control custom-checkbox">
                                                                        <input :id="`checkbox${i}`" type="checkbox" class="custom-control-input" :name="`checkbox${i}`" :value="item" v-model="daily_tasks"/>
                                                                        <label :for="`checkbox${i}`" class="custom-control-label ml-2"/>
                                                                    </span>
                                                                </td>
                                                                <td v-html="item.name"/>
                                                                <td v-html="item.description"/>
                                                                <td>
                                                                    <span>
                                                                        <input  :id="`policing_frequency${i}`" type="number" class="form-control" v-model="item.frequency" :placeholder="'Daily frequency'"/>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`order${i}`" type="number" class="form-control" v-model="item.order" :placeholder="'Order'"/>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="tab-pane fade" id="policing" role="tabpanel" aria-labelledby="instant-tab">
                                <div class="tab-content">
                                    <div class="tab-pane fade active show" >
                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="w-100 table-responsive overflow-y--1">
                                                    <table class="table">
                                                        <thead style="background-color: #f1f1f1;">
                                                            <tr>
                                                                <th v-for="(item, i) in task_table_headers" :key="i" scope="col" v-html="item.name"/>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr v-for="(item, i) in policings" :key="i">
                                                                <td>
                                                                    <span class="custom-control custom-checkbox">
                                                                        <input :id="`checkboxPolicing${i}`" type="checkbox" class="custom-control-input" name="policing" :value="item" v-model="policing_tasks"/>
                                                                        <label :for="`checkboxPolicing${i}`" class="custom-control-label ml-2"/>
                                                                    </span>
                                                                </td>
                                                                <td v-html="item.name"/>
                                                                <td v-html="item.description"/>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`policing_frequency_policing${i}`" type="number" class="form-control" v-model="item.frequency" :placeholder="'Policing frequency'"/>
                                                                    </span>
                                                                </td>
                                                                <td>
                                                                    <span>
                                                                        <input :id="`order_policing${i}`" type="number" class="form-control" v-model="item.order" :placeholder="'Order'"/>
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources   from  './form_resources'
import Resources       from  './resources'
import FormDynamic     from  '@/components/FormDynamic.vue'
import Breadcrumb      from  '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal       from  '@/components/BaseModal'
import CentralButtons  from  '@/components/CentralButtons'

export default {

    name:   'FormModal',

    props: [
        'title',
        'content_header',
        'rest_api',
        'notifications',
        'notyf',
        'axios',
        'array_options',
        'tasks',
        'policings',
        'breadcrumb',
    ],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return{
            levels: [],
            areas: [],
            form_data: FormResources.form_data,
            form_format: FormResources.form_format,
            task_table_headers: Resources.task_table_headers,
            tabs: Resources.tabs,
            form_backup: {...FormResources.form_data},
            daily_tasks: [],
            policing_tasks: [],
        }
    },

    watch: {

        "form_data.unit"(val)
        {
            if(val < 1 || val > 6)
            {
                this.form_data.unit = 1
            }
        }

    },

    methods:{

        async form_submit_ext()
        {

            if(this.form_data.unit < 1 || this.form_data.unit > 6)
            {
                this.notyf.error("Unit can't be lower than 1 nor higher than 6 either")
                return false
            }

            let validateTasks = (tasks) => 
            {
                return tasks.some(task => task.frequency === '' || task.order === '');
            };

            let frequency_daily_task_validation = validateTasks(this.daily_tasks);
            let frequency_policing_task_validation = validateTasks(this.policing_tasks);

            if (frequency_daily_task_validation || frequency_policing_task_validation) 
            {
                this.notyf.error('Frequency cannot be empty');
            }

            if (validateTasks(this.daily_tasks.concat(this.policing_tasks))) 
            {
                this.notyf.error('Order cannot be empty');
            }

            if (frequency_daily_task_validation || frequency_policing_task_validation) 
            {
                return false;
            }


            this.form_data.daily_tasks = this.daily_tasks
            this.form_data.policing_tasks = this.policing_tasks


            await this.form_submit()

            this.form_data.daily_tasks = []
            this.form_data.policing_tasks = []
            this.$emit('cleanUp')
        }

    },

    mounted(){

    }
    
}
</script>